import * as React from 'react';
import Page from '../containers/Page';

export default () => (
  <Page title="Logout">
      log out
    </Page>
)